<div class="breadcrumbs d-flex align-items-center mb-4">
    <ng-content></ng-content>
</div>
